class CartNotification extends HTMLElement {
    constructor() {
        super();
        this.notification = document.getElementById('cart-notification');
        this.addEventListener('click', this.onUpsellAdd.bind(this));
        this.contentReady = false;
        this.loadPromise = null;
        this.contentVersion = 0;
        this.openRequested = false;
        this.closeTimeoutID = null;
    }
    onUpsellAdd(event) {
        const button = event.target.closest('[data-cart-upsell-add]');
        if (!button || button.disabled) return;

        const variantId = Number(button.dataset.variantId);
        const errorElement = button.closest('.homeax-cart-upsell__content')?.querySelector('[data-cart-upsell-error]');
        const labelElement = button.querySelector('[data-cart-upsell-label]');
        if (!variantId) return;

        button.disabled = true;
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        if (errorElement) errorElement.textContent = '';

        fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                items: [{ id: variantId, quantity: 1 }],
                sections: this.getSectionsToRender().map((section) => section.id),
                sections_url: window.location.pathname
            })
        })
        .then(async (response) => {
            const parsedState = await response.json();
            if (!response.ok || parsedState.status) {
                throw new Error(parsedState.description || parsedState.message || 'This item could not be added.');
            }
            if (labelElement) labelElement.textContent = 'Added';
            button.classList.remove('is-loading');
            button.classList.add('is-added');
            button.removeAttribute('aria-busy');
            // The addition succeeded; a rendering failure must not invite a duplicate add.
            button.dataset.cartAdded = 'true';
            this.renderContents(parsedState);
        })
        .catch((error) => {
            if (errorElement) errorElement.textContent = error.message;
            button.disabled = button.dataset.cartAdded === 'true';
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
        });
    }
    renderContentsOnLoad() {
        if (this.loadPromise) return this.loadPromise;
        const version = this.contentVersion;
        const readJson = (url) => fetch(url).then((response) => {
            if (!response.ok) throw new Error('Cart could not be loaded.');
            return response.json();
        });
        const load = Promise.all([
            readJson(`${window.Shopify.routes.root}?sections=cart-notification-content,cart-notification-crosssell-products`),
            readJson(`${window.Shopify.routes.root}cart.js`)
        ]).then(([sections, cart]) => {
            if (version !== this.contentVersion) return;
            if (!this.updateContent(sections)) throw new Error('Cart content is unavailable.');
            this.contentReady = true;
            window.initFreeshippingGoal(cart);
            window.cartCount(cart);
            this.renderCrosssell(sections);
        }).finally(() => {
            if (this.loadPromise === load) this.loadPromise = null;
        });
        this.loadPromise = load;
        return load;
    }
    renderCrosssell(sections) {
        const html = sections?.['cart-notification-crosssell-products'];
        if (typeof html !== 'string' || !html.trim()) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        if (!parsed.querySelector('#shopify-section-cart-notification-crosssell-products')) return;
        window.renderCrosssellProducts(sections);
    }
    async open(autoClose) {
        clearTimeout(this.closeTimeoutID);
        this.closeTimeoutID = null;
        this.openRequested = true;
        if (!this.contentReady) {
            this.setAttribute('aria-busy', 'true');
            try {
                await this.renderContentsOnLoad();
            } catch (error) {
                console.error(error);
                if (this.openRequested) window.location.assign(`${window.Shopify.routes.root}cart`);
                return;
            } finally {
                this.removeAttribute('aria-busy');
            }
        }
        if (!this.openRequested || !this.notification) return;
        this.notification.classList.add('active');
        document.body.classList.add('minicart-active');
        document.body.style.marginRight = (window.innerWidth - $(window).width())  + 'px';
    }
    close() {
        this.openRequested = false;
        $('.cart-item__error-text').empty();
        this.notification?.classList.remove('active');
        clearTimeout(this.closeTimeoutID);
        this.closeTimeoutID = setTimeout(() => {
            this.closeTimeoutID = null;
            if (this.openRequested) return;
            document.body.classList.remove('minicart-active');
            document.body.style.marginRight = '0px';
        },300);
    }
    renderContents(parsedState) {
        if (!parsedState || typeof parsedState !== 'object') return;
        const version = ++this.contentVersion;
        // Invalidate an older initial load without letting its response overwrite this update.
        this.loadPromise = null;
        const sections = parsedState.sections;
        this.contentReady = this.updateContent(sections);
        this.renderCrosssell(sections);
        if (this.contentReady) {
            if (Number.isFinite(parsedState.item_count) && Number.isFinite(parsedState.total_price)) {
                window.initFreeshippingGoal(parsedState);
                window.cartCount(parsedState);
            } else {
                fetch(`${window.Shopify.routes.root}cart.js`)
                    .then((response) => {
                        if (!response.ok) throw new Error('Cart totals could not be loaded.');
                        return response.json();
                    })
                    .then((cart) => {
                        if (version !== this.contentVersion) return;
                        window.initFreeshippingGoal(cart);
                        window.cartCount(cart);
                    }).catch(console.error);
            }
        }
        this.open();
    }
    updateContent(parsedStateSections) {
        if (!parsedStateSections || typeof parsedStateSections !== 'object') return false;
        let updatedCart = false;
        var _this = this;
        this.getSectionsToRender().forEach((section => {
            const target = document.getElementById(section.id);
            const html = parsedStateSections[section.id];
            if (!target || typeof html !== 'string' || !html.trim()) return;
            const parsedStateHtml = new DOMParser().parseFromString(parsedStateSections[section.id], 'text/html');
            if (!parsedStateHtml.querySelector('.shopify-section')) return;
            if (section.id === 'cart-notification-content') updatedCart = true;
            target.querySelector('.swiper')?.swiper?.destroy(true, true);
            
            if (section.id == 'cart-notification-content') {
                if (parsedStateHtml.querySelector('.empty-mini-cart')) {
                    document.getElementById('cart-notification-content').classList.add('h-100');
                } else {
                    document.getElementById('cart-notification-content').classList.remove('h-100');
                }
            }

            if (section.id == 'cart-notification-content' && section.hasOwnProperty('elements') && document.getElementById(section.id).querySelector('[data-mini-cart-wrapper]') && parsedStateHtml.querySelector('[data-mini-cart-wrapper]')) {
                section['elements'].forEach(function(elem) {
                    if (!target.querySelector(elem)) return;
                    const content = _this.getSectionInnerHTML(parsedStateSections[section.id], elem);
                    if (content != '') {
                        document.getElementById(section.id).querySelector(elem).classList.remove('d-none');
                        document.getElementById(section.id).querySelector(elem).innerHTML = content;
                    } else {
                        document.getElementById(section.id).querySelector(elem).classList.add('d-none');
                    }
                });
            } else {
                document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedStateSections[section.id]);
            }
        }));
        return updatedCart;
    }
    getSectionsToRender() {
        return [
            {
                id: 'cart-notification-content',
                elements: ['[data-cart-title]', '[data-mini-cart-wrapper]']
            },
            {
                id: 'cart-notification-crosssell-products'
            }
        ];
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
        const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
        return parsedHtml.querySelector(selector) ? parsedHtml.querySelector(selector).innerHTML : ''; 
    }
    setActiveElement(element) {
        this.activeElement = element;
    }
}
customElements.define('cart-notification', CartNotification);
